import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { ShieldAlert, ChevronRight } from "lucide-react";
import { STATUS_META, fmtDt } from "../lib/incidents";

/** Compact card on the customer portal that lists any incidents attached
 *  to the customer. Hidden entirely when they have none. */
export default function CustomerIncidentsCard({ lang = "no" }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/incidents")
            .then((r) => setItems(r.data || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);

    if (loading || items.length === 0) return null;

    return (
        <Card
            className="p-5 sm:p-6 border-l-4 border-l-red-500"
            data-testid="customer-incidents-card"
        >
            <div className="flex items-start gap-3">
                <div className="p-2.5 rounded-lg bg-red-100 text-red-600 shrink-0">
                    <ShieldAlert className="w-5 h-5" />
                </div>
                <div className="flex-1 min-w-0">
                    <h2 className="text-xl font-semibold text-[#0C1824]">
                        {lang === "no" ? "Dine skadesaker" : "Your incident cases"}
                    </h2>
                    <p className="text-sm text-[#2B3F4D] mt-1">
                        {lang === "no"
                            ? "Se status, send meldinger og last opp dokumenter til aktive saker."
                            : "See status, send messages and upload documents on your active cases."}
                    </p>
                    <div className="mt-4 space-y-2">
                        {items.map((it) => {
                            const st = STATUS_META[it.status] || STATUS_META.open;
                            return (
                                <Link
                                    key={it.id}
                                    to={`/incidents/${it.id}`}
                                    className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 hover:border-[#BD984D]/50 hover:bg-[#BD984D]/5 p-3 transition"
                                    data-testid={`customer-incidents-link-${it.id}`}
                                >
                                    <div className="min-w-0">
                                        <div className="flex items-center gap-2 text-xs uppercase tracking-widest">
                                            <span className="font-mono text-[#A57F39] font-semibold">
                                                {it.reference_no}
                                            </span>
                                            <span className={`px-2 py-0.5 rounded-full border ${st.cls}`}>
                                                {lang === "no" ? st.no : st.en}
                                            </span>
                                        </div>
                                        <div className="font-medium text-[#0C1824] mt-1 truncate">
                                            {it.title}
                                        </div>
                                        <div className="text-xs text-[#2B3F4D] mt-0.5">
                                            {fmtDt(it.created_at, lang)}
                                        </div>
                                    </div>
                                    <ChevronRight className="w-5 h-5 text-[#A57F39] shrink-0" />
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Card>
    );
}
